import styled from '@emotion/styled';
import { common } from '@libs/domain';
import { DatePickerField, LabelField, TextStringField, useLocalizedContents } from '@ps-smart-cp/ppfw-client';
import { useCompany } from '../context';
import { ledgerFooterFieldConfig } from '../item-config';
import type { LedgerFooter } from '../models';
import { calcEntryMonth, getEntryMonthByLocale } from '../services';

interface LedgerFooterFormProps {
  ledgerFooter: LedgerFooter;
  setLedgerFooter: (t: LedgerFooter) => void;
  /**
   * 下段を非表示にするかどうか
   */
  isLowerHidden?: boolean;
  /**
   * 稟議決裁番号を非表示にするかどうか
   */
  isApprovalNoHidden?: boolean;
  /**
   * 計上年月日を必須にするかどうか
   */
  isEntryDateRequired?: boolean;
  /**
   * 計上年月日を非活性にするかどうか
   */
  isEntryDateDisable?: boolean;
  errorFields?: string[];
}

const FooterLeft = styled.div`
  float: left;
  width: 356px;
`;
const FooterRight = styled.div`
  .form-field {
    clear: none;
    display: flex;
  }
`;

export function LedgerFooterForm({
  ledgerFooter,
  setLedgerFooter,
  isLowerHidden,
  isApprovalNoHidden,
  isEntryDateRequired,
  isEntryDateDisable,
  errorFields,
}: LedgerFooterFormProps) {
  const { locale } = useLocalizedContents();
  const { accountingPolicy } = useCompany();

  return (
    <>
      <FooterLeft>
        <DatePickerField
          componentType="ymd"
          items={ledgerFooterFieldConfig}
          obj={ledgerFooter}
          setObj={setLedgerFooter}
          prop="entryDate"
          errorFields={errorFields}
          prioritizedRequired={isEntryDateRequired}
          disabled={isEntryDateDisable}
        />
      </FooterLeft>
      <FooterRight>
        <LabelField
          itemName={common.names.entryMonth}
          value={getEntryMonthByLocale(
            calcEntryMonth(ledgerFooter.entryDate, accountingPolicy) ?? '',
            locale,
          )}
          fieldBodyStyle={{ backgroundColor: 'transparent' }}
        />
      </FooterRight>
      {!isLowerHidden &&
        (isApprovalNoHidden ? (
          <FooterRight>
            <TextStringField
              items={ledgerFooterFieldConfig}
              obj={ledgerFooter}
              setObj={setLedgerFooter}
              prop="summary"
              errorFields={errorFields}
            />
          </FooterRight>
        ) : (
          <>
            <FooterLeft>
              <TextStringField
                items={ledgerFooterFieldConfig}
                obj={ledgerFooter}
                setObj={setLedgerFooter}
                prop="approvalNo"
                errorFields={errorFields}
              />
            </FooterLeft>
            <FooterRight>
              <TextStringField
                items={ledgerFooterFieldConfig}
                obj={ledgerFooter}
                setObj={setLedgerFooter}
                prop="summary"
                innerComponentStyle={{ maxWidth: '270px' }}
                errorFields={errorFields}
              />
            </FooterRight>
          </>
        ))}
    </>
  );
}

export type { LedgerFooterFormProps };
export { FooterLeft, FooterRight };
